/**
 * 认证相关辅助函数
 * @description 从 userStore 抽取的错误处理逻辑
 */

import { STORAGE_KEYS } from '@/constants'
import { isApiError } from '@/types/api'

/**
 * 错误码消息映射
 */
const ERROR_CODE_MESSAGES: Record<string, string> = {
  B1001: '用户名或密码错误',
  B1004: '验证码错误',
  B1005: '验证码已过期，请重新获取',
  A1000: '登录令牌无效',
  A1001: '登录令牌无效',
  S1001: '服务器错误，请稍后重试',
}

/**
 * 处理登录错误
 * @description 根据错误类型返回用户友好的错误消息
 * @param error 未知类型错误
 * @returns 错误消息字符串
 */
export function handleLoginError(error: unknown): string {
  if (!isApiError(error)) {
    if (error instanceof Error) {
      return error.message || '登录失败，请稍后重试'
    }
    return '登录失败，请稍后重试'
  }

  if (error.response?.data && typeof error.response.data === 'object') {
    const data = error.response.data as { msg?: string, detail?: string, message?: string }
    if (data.msg) {
      return data.msg
    }
    if (data.detail && typeof data.detail === 'string') {
      return data.detail
    }
    if (data.message && typeof data.message === 'string') {
      return data.message
    }
  }

  if (error.code && ERROR_CODE_MESSAGES[error.code]) {
    return ERROR_CODE_MESSAGES[error.code]
  }

  if (error.message && typeof error.message === 'string') {
    return error.message
  }

  return '登录失败，请稍后重试'
}

/**
 * 强制彻底清除本地所有认证相关的存储状态
 * 供 Axios 拦截器等非 Vue 响应式上下文中调用，避免循环引用
 */
export function forceClearAuthState(): void {
  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem(STORAGE_KEYS.USER_STORE_V2)
    localStorage.removeItem(STORAGE_KEYS.USER_STORE_V1)
    localStorage.removeItem(STORAGE_KEYS.ADMIN_TOKEN)
    localStorage.removeItem(STORAGE_KEYS.USER_TOKEN)
    localStorage.removeItem(STORAGE_KEYS.LEGACY_TOKEN)
    localStorage.removeItem(STORAGE_KEYS.LEGACY_USER_INFO)
    localStorage.removeItem(STORAGE_KEYS.LEGACY_REFRESH_TOKEN)
  }
}
